import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-93d44c3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "hljs-container",
  codetype: "Java"
}
const _hoisted_2 = { class: "hljs-code-number" }

import vCode from './line';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    tocode: {
        type: String,
        default: '',
    },
    
},
  setup(__props) {

const props = __props
let num = props.tocode.split('\n').length
let numlist = [...Array(num).keys()]





return (_ctx: any,_cache: any) => {
  const _component_highlightjs = _resolveComponent("highlightjs")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numlist), (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item+1), 1))
      }), 128))
    ]),
    _createVNode(_component_highlightjs, { code: __props.tocode }, null, 8, ["code"])
  ])), [
    [_unref(vCode)]
  ])
}
}

})